
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"52","cy":"52","r":"52","fill":"currentColor"}}),_c('path',{attrs:{"d":"M45.46 52.354h-1.418v4.86H32.077V46.382h9.328v-1.418H30.659v13.668H45.46v-6.278z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M38.025 53.546l-2.81-2.807-1.002 1.002 3.881 3.877 8.305-9.478-1.066-.934-7.308 8.34zm6.017 21.485H32.077V64.199h9.328v-1.418H30.659v13.668H45.46v-6.277h-1.418v4.859z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M38.025 71.363l-2.81-2.805-1.002 1.003 3.881 3.875 8.305-9.479-1.066-.934-7.308 8.34zm7.435-36.827h-1.418v4.86H32.077V28.563h9.328v-1.417H30.659v13.667H45.46v-6.277z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M38.025 35.728l-2.81-2.807-1.002 1.003 3.881 3.876 8.305-9.479-1.066-.933-7.308 8.34zm23.454 4.781c-4.006 0-11.861 1.9-11.861 6.277v10.023a5.4 5.4 0 004.461 5.1v16.059H55.5V49.014h-1.421v11.455a4.078 4.078 0 01-3.043-3.66V46.786c0-3.015 6.762-4.859 10.443-4.859s10.444 1.844 10.444 4.859v10.023a4.078 4.078 0 01-3.043 3.66V49.014h-1.418v28.954h1.418V61.91a5.4 5.4 0 004.461-5.1V46.786c0-4.386-7.855-6.277-11.862-6.277zm0-1.923a5 5 0 005.17-5.163V31.2a5.17 5.17 0 00-10.339 0v2.228a5 5 0 005.169 5.158zM57.728 31.2a3.752 3.752 0 017.5 0v2.228a3.752 3.752 0 01-7.5 0z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M60.771 60.149h1.418v17.818h-1.418z","fill":"currentColor"}})])
          )
        }
      }
    